<div class="data-table-container" #tableContainer>
  <!-- MatSort gère automatiquement les icônes de tri -->
  <table cdk-table 
         [dataSource]="paginatedData()" 
         class="data-table"
         matSort
         (matSortChange)="onSortChange($event)"
         cdkDropList
         cdkDropListOrientation="horizontal"
         (cdkDropListDropped)="drop($event)">

    <!-- Dynamic Columns avec @for (Angular 21) -->
    @for (column of columns(); track column.key) {
      <ng-container [cdkColumnDef]="column.key">
        <th cdk-header-cell cdkDrag *cdkHeaderCellDef mat-sort-header>
          {{ column.label | translate }}
        </th>
        <td cdk-cell *cdkCellDef="let row">
          {{ getCellValue(row, column.key) }}
        </td>
      </ng-container>
    }
    
    <!-- Header Row -->
    <tr cdk-header-row *cdkHeaderRowDef="displayedColumns()"></tr>
    
    <!-- Data Rows -->
    <tr #dataRow cdk-row *cdkRowDef="let row; columns: displayedColumns(); let i = index" 
        [attr.data-row-key]="row[highlightedRowKey()]"
        [class.clickable]="clickable()"
        [class.highlighted]="isHighlightedRow(row)"
        tabindex="-1"
        (click)="onRowClick(row)"></tr>
  </table>
</div>
